import { Action } from '@ngrx/store';
import { SXError } from '../../../models/sx-error.model';

export enum ErrorActionTypes {
    ErrorAdd = '[Errors] Add',
    ErrorsClear = '[Errors] Clear'
}

export class ErrorAdd implements Action {
    readonly type = ErrorActionTypes.ErrorAdd;
    constructor(public payload: SXError) { }
}

export class ErrorsClear implements Action {
    readonly type = ErrorActionTypes.ErrorsClear;
    constructor() { }
}

export type ErrorsActions =
    ErrorAdd
    | ErrorsClear;